import ImpactCrusherCI from './ImpactCrusherCI.png';
import HSIBW from '../../Generic/GenericCrusher/images/HSIBW.png';
import ImpactCrusherCI2 from './ImpactCrusherCI_2.png';

export const getImageImpactCrusherCI = (showCustomModel: boolean) => {
  return showCustomModel ? HSIBW : ImpactCrusherCI;
};

export const getImageImpactCrusherCI2 = (showCustomModel: boolean) => {
  return showCustomModel ? HSIBW : ImpactCrusherCI2;
};
